import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20style%20dramatic%20cinematic%20scene%2C%20warm%20golden%20and%20rose%20gradient%20background%2C%20abstract%20flowing%20ink%20patterns%2C%20soft%20atmospheric%20lighting%2C%20ethereal%20glow%2C%20artistic%20painterly%20composition%2C%20dreamy%20fantasy%20atmosphere%2C%20delicate%20particles%2C%20no%20characters%2C%20mood%20piece%2C%20elegant%20visual%20storytelling&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="韩漫画免费阅读"
        title="韩漫画免费阅读 - 好看的韩国漫画大全"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <span className="inline-block px-4 py-1.5 rounded-full text-xs md:text-sm font-medium bg-white/15 backdrop-blur-sm text-white border border-white/20 mb-5 md:mb-6">
          海量韩漫 · 免费阅读 · 下拉式体验
        </span>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight max-w-3xl">
          好看的韩国漫画大全
          <span className="block text-2xl md:text-4xl lg:text-5xl font-normal italic mt-2 text-white/90">
            下拉式阅读 · 畅享每一话
          </span>
        </h1>
        <p className="mt-4 md:mt-6 text-sm md:text-base text-white/70 max-w-xl">
          韩漫画免费阅读平台，更新及时体验流畅，让您轻松追更和享受阅读乐趣
        </p>
        <div className="mt-7 md:mt-9 flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/romance"
            className="px-7 py-3 rounded-full text-sm md:text-base font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            开始阅读
            <i className="ri-arrow-right-line ml-1.5"></i>
          </Link>
          <Link
            to="/#ranking"
            className="px-7 py-3 rounded-full text-sm md:text-base font-medium bg-white/15 backdrop-blur-sm text-white hover:bg-white/25 transition-colors duration-200 whitespace-nowrap"
          >
            热门排行
            <i className="ri-fire-line ml-1.5"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}